import React, { useState } from 'react';
import jobs from '../data/jobs';

const locationOptions = ['All', ...Array.from(new Set(jobs.map(j => j.location)))];
const industryOptions = ['All', ...Array.from(new Set(jobs.map(j => j.industry)))];

const Jobs = () => {
  const [location, setLocation] = useState('All');
  const [industry, setIndustry] = useState('All');
  const [titleSearch, setTitleSearch] = useState('');
  const [showTitleDropdown, setShowTitleDropdown] = useState(false);
  const titleOptions = Array.from(new Set(jobs.map(j => j.title))).filter(Boolean);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const baseJobs = jobs
    .filter(job => {
      const isActive = job.accountstatus === true || job.accountstatus === 'A' || job.accountstatus === 'true' || job.accountstatus === 1;
      const expiryDate = job.dateofexpiry ? new Date(job.dateofexpiry) : null;
      const hasValidExpiry = expiryDate instanceof Date && !Number.isNaN(expiryDate.getTime());
      return isActive && hasValidExpiry && expiryDate >= today;
    })
    .sort((a, b) => (Number(a.listorder) || 0) - (Number(b.listorder) || 0));

  let filteredJobs = baseJobs;
  if (location !== 'All') filteredJobs = filteredJobs.filter(j => j.location === location);
  if (industry !== 'All') filteredJobs = filteredJobs.filter(j => j.industry === industry);
  if (titleSearch.trim() !== '') filteredJobs = filteredJobs.filter(j => (j.title || '').toLowerCase().includes(titleSearch.trim().toLowerCase()));

  return (
    <div style={{ padding: '0', margin: '0', marginLeft: '12px', maxWidth: 1200 }}>
      <h2 style={{ margin: 0 , color: '#1976d2', marginBottom: '0.7rem', fontSize: '1.25rem', letterSpacing: '0.01em', fontWeight: 600, textShadow: '0 2px 8px #e3f2fd' }}>Job Listings</h2>
      <div style={{ margin: 0, display: 'flex', gap: '0.1rem', flexWrap: 'wrap', alignItems: 'center', background: '#f5faff', borderRadius: 10, padding: '0.2rem 0.3rem', boxShadow: '0 2px 12px rgba(25, 118, 210, 0.07)', marginBottom: '0.3rem' }}>
        <div>
          <label htmlFor="location-select" style={{ fontWeight: 500, fontSize: '.90rem', marginBottom:'.5rem', marginRight: 8, color: '#1976d2' }}>Location:</label>
          <select
            id="location-select"
            value={location}
            onChange={e => setLocation(e.target.value)}
            style={{ padding: '0.38rem 0.7rem', borderRadius: 8, border: '1px solid #90caf9', fontSize: '.90rem', height: '2.1rem', width: 110, background: '#fff' }}
          >
            {locationOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="industry-select" style={{ fontWeight: 500, marginRight: 8, fontSize: '.90rem',color: '#1976d2' }}>Industry:</label>
          <select
            id="industry-select"
            value={industry}
            onChange={e => setIndustry(e.target.value)}
            style={{ padding: '0.38rem 0.7rem', borderRadius: 8, border: '1px solid #90caf9', fontSize: '.90rem', height: '2.1rem', width: 140, background: '#fff' }}
          >
            {industryOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="title-search" style={{ fontWeight: 500, marginRight: 8, color: '#1976d2' }}>Search:</label>
          <div style={{ position: 'relative', display: 'inline-block', marginBottom: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                id="title-search"
                type="text"
                value={titleSearch}
                onChange={e => setTitleSearch(e.target.value)}
                onFocus={() => setShowTitleDropdown(true)}
                onBlur={() => setTimeout(() => setShowTitleDropdown(false), 150)}
                placeholder="Type job title..."
                style={{ padding: '0.22rem 0.7rem', borderRadius: 8, border: '1px solid #90caf9', fontSize: '1rem', height: '1.4rem', width: 180, background: '#fff' }}
              />
              <button
                type="button"
                onClick={() => setTitleSearch('')}
                style={{ marginLeft: 6, padding: '0.38rem 0.7rem', borderRadius: 8, border: '1px solid #90caf9', background: '#e3f2fd', fontSize: '.80rem', cursor: 'pointer', height: '2.1rem', color: '#1976d2', fontWeight: 600 }}
              >
                Clear
              </button>
            </div>
            {showTitleDropdown && (
              <div style={{ position: 'absolute', background: '#fff', border: '1px solid #90caf9', borderRadius: 8, boxShadow: '0 2px 8px rgba(25,118,210,0.10)', marginTop: 2, zIndex: 10, minWidth: 180, maxHeight: 200, overflowY: 'auto' }}>
                {titleOptions
                  .filter(t => t.toLowerCase().includes(titleSearch.toLowerCase()))
                  .map(title => (
                    <div
                      key={title}
                      style={{ padding: '0.4rem 0.7rem', cursor: 'pointer', fontSize: '1rem', color: '#1976d2', fontWeight: 500, borderBottom: '1px solid #e3f2fd' }}
                      onMouseDown={() => { setTitleSearch(title); setShowTitleDropdown(false); }}
                    >
                      {title}
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
  <p style={{ marginBottom: '1em', color: '#1976d2', fontWeight: 600, fontSize: '9px' }}>{filteredJobs.length} jobs listed</p>
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.6rem' }}>
        {filteredJobs.map(job => (
          <div key={job.id} style={{ border: '1px solid #90caf9', borderRadius: '14px', padding: '1.2rem 1.1rem 1.1rem 1.1rem', width: '340px', minHeight: '260px', background: '#fff', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', wordWrap: 'break-word', whiteSpace: 'normal', boxShadow: '0 4px 18px rgba(25,118,210,0.08)', transition: 'box-shadow 0.2s', position: 'relative' }}
            onMouseOver={e => e.currentTarget.style.boxShadow = '0 8px 32px rgba(25,118,210,0.16)'}
            onMouseOut={e => e.currentTarget.style.boxShadow = '0 4px 18px rgba(25,118,210,0.08)'}
          >
            <div style={{ fontWeight: 700, fontSize: '1.18rem', marginBottom: 4, color: '#1976d2', letterSpacing: '0.01em' }}>{job.title}</div>
            <div style={{ color: '#388e3c', fontWeight: 600, fontSize: '1.05rem', marginBottom: 2 }}>{job.company}</div>
            <div style={{ color: '#0288d1', fontSize: '0.98rem', marginBottom: 2 }}>Industry: <span style={{ color: '#222' }}>{job.industry}</span></div>
            <div style={{ color: '#0288d1', fontSize: '0.98rem', marginBottom: 2 }}>Location: <span style={{ color: '#222' }}>{job.location}</span></div>
            <div style={{ color: '#0288d1', fontSize: '0.98rem', marginBottom: 2 }}>Type: <span style={{ color: '#222' }}>{job.type}</span></div>
            <div style={{ color: '#555', fontSize: '0.97rem', marginBottom: 2, marginTop: 2 }}>Description: <span style={{ color: '#444' }}>{job.description}</span></div>
            <div style={{ color: '#9c8686', fontWeight: 600, marginTop: 2 }}>Contact Person: {job.contactperson || '-'}</div>
            <div style={{ color: '#9c8686', fontWeight: 600, marginTop: 2 }}>Email: {job.contactemail || '-'}</div>
            <div style={{ color: '#9c8686', fontWeight: 600, marginTop: 2 }}>Phone: {job.contactnumber || '-'}</div>
            <div style={{ color: '#757575', fontSize: '0.93rem', marginTop: '0.7rem', fontStyle: 'italic' }}>Date Posted: {job.datePosted}</div>
            <div style={{ color: '#757575', fontSize: '0.93rem', marginTop: '0.2rem', fontStyle: 'italic' }}>Expiry: {job.dateofexpiry}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Jobs;